import React  from 'react';
import { useField } from 'formik';
import RichTextEditor from "../RichTextEditor";

const FormikRichTextEditor = (props) => {
  const [field, meta, helpers] = useField(props);
  const onChange = (state) => {
    helpers.setValue(state);
  };

  const mceOptions = props.mceOptions || {
    plugins: [],
    options: {}
  };

  return (
    <div>
      <RichTextEditor
        label={props.label}
        id={props.name}
        name={field.name}
        value={field.value}
        onChange={onChange}
        mceOptions={mceOptions}
      />
    </div>
  )
};

RichTextEditor.defaultProps = {
  autoFocus: true
}

export default FormikRichTextEditor;
